import { LogicalOperator, ValueExpression } from '@mtna/data-query-ts';

export class FilterGroup {
  constructor(public valueExpression?: ValueExpression, public groups?: FilterGroup[], public postOperator?: LogicalOperator) {}
}
